import React, { useState, useEffect } from 'react'
import { PanelGroup, Panel, Row, Col, Message, Form, FormGroup } from 'rsuite'
// import { Checkbox, CheckboxGroup } from 'rsuite';
import { IconButton, Icon, Input, InputNumber, InputGroup, Checkbox, CheckboxGroup } from 'rsuite'
import CustomIconMessageInfo from '../../../widgets/CustomIconMessageInfo'
import { isRequired, isValidators, getMaxLengthData } from '../../../utils/ValidatorUtils'
import NumberFormat from 'react-number-format'
import ShowLimitLength from '../../../components/utils/ShowLimitLength'
import CustomAlertMessageInfo from '../../CustomAlertMessageInfo'
import CustomNote from '../../CustomNote'

const personstyles = {
  //width: 180,
  marginBottom: 10,
}
const detailstyles = {
  //width: 500,
  marginBottom: 10,
}

export default function TargetGroup({
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  clearErrors,
  isConfirmActualResult,
}) {
  const [checkAll, setCheckAll] = useState()

  const [checkBoxList, setCheckBoxList] = useState([])
  const [detailList, setDetailList] = useState([])
  const [numOfPeopleList, setNumOfPeopleList] = useState([])

  const [schema, setSchema] = useState(_schema)
  const [textLength, setTextLength] = useState(schema?.targetCriteria?.value?.length || 0)

  useEffect(() => {
    // console.log(
    //   schema.criteriaList.name,
    //   Array.isArray(schema.criteriaList.optionSelected) ? schema.criteriaList.optionSelected : []
    // )
    if (
      Array.isArray(schema.criteriaList.optionSelected) &&
      schema.criteriaList.optionSelected.length > 0
    ) {
      // console.log('schema.criteriaList.optionSelected', schema.criteriaList.optionSelected)
      setCheckBoxList(schema.criteriaList.optionSelected)
      setValue(schema.criteriaList.name, schema.criteriaList.optionSelected)
    } else {
      setValue(schema.criteriaList.name)
    }

    //initial current textlength for detail
    var newSchema = schema.criteriaList.options.map((item) => {
      item.detail.length = item.detail.value.length
    })
  }, [schema])

  const updateSchemaValue = () => {
    setSchema((state) => ({
      ...state,
      schema,
    }))
  }

  const handleChange = (value) => {
    if (value.length === 0) {
      setValue(schema.criteriaList.name)
    } else {
      setValue(schema.criteriaList.name, value)
    }
    setCheckBoxList(value)
    setSchema((state) => ({
      ...state,
      criteriaList: {
        ...state.criteriaList,
        optionSelected: value,
      },
    }))
    updateSchemaValue()
  }

  const inputDetailChange = (value, index) => {
    // console.log('value', value, 'index', index)
    schema.criteriaList.options[index].detail.value = value
    updateSchemaValue()
  }

  const inputNumOfPeopleChange = (value, index, paramName) => {
    // console.log('value', value, 'index', index)
    schema.criteriaList.options[index].value
    schema.criteriaList.options[index].numberOfPeople.value = value

    setValue(paramName, value)
    clearErrors(paramName)
    updateSchemaValue()
  }

  const inputUnitChange = (value, index) => {
    // console.log('value', value, 'index', index)
    schema.criteriaList.options[index].unit.value = value
    updateSchemaValue()
  }

  const generateCheckbox = () => {
    return schema.criteriaList.options.map((item, index) => {
      const isDisabled = !schema.criteriaList.optionSelected.some((e) => e === item.value)

      return (
        <>
          {errors[item.detail.name] && (
            <Message showIcon type="error" description={errors[item.detail.name].message} />
          )}
          {errors[item.numberOfPeople.name] && (
            <Message showIcon type="error" description={errors[item.numberOfPeople.name].message} />
          )}
          <Row>
            <Col xs={24} sm={24} md={8} lg={8}>
              <Checkbox value={item.value}>{item.text}</Checkbox>
            </Col>
            <Col xs={24} sm={24} md={6} lg={6}>
              <InputGroup style={personstyles} disabled={isDisabled}>
                <InputGroup.Addon>{item.numberOfPeople.preText}</InputGroup.Addon>
                <Controller
                  key={item.numberOfPeople.name}
                  name={item.numberOfPeople.name}
                  control={control}
                  rules={{
                    required: isDisabled
                      ? false
                      : 'กรุณากรอก ' + item.numberOfPeople.preText + item.numberOfPeople.postText,
                  }}
                  // value={item.numberOfPeople.value}
                  defaultValue={item.numberOfPeople.value}
                  render={(props) => {
                    return (
                      // <InputNumber
                      //   value={item.numberOfPeople.value}
                      //   onChange={(e) => inputNumOfPeopleChange(e, index, item.numberOfPeople.name)}
                      // />
                      <NumberFormat
                        className="rs-input"
                        thousandSeparator={true}
                        value={item.numberOfPeople.value}
                        onValueChange={(value) => {
                          inputNumOfPeopleChange(value.floatValue, index, item.numberOfPeople.name)
                        }}
                      />
                    )
                  }}
                />
                {/* <InputGroup.Addon>{item.numberOfPeople.postText}</InputGroup.Addon> */}
                {item.unit ? (
                  <>
                    <InputGroup.Addon>{item.unit.text}</InputGroup.Addon>
                    <Input
                      name={item.unit.name}
                      value={item.unit.value}
                      inputRef={register}
                      onChange={(e) => inputUnitChange(e, index)}
                    />
                  </>
                ) : (
                  <InputGroup.Addon>{item.numberOfPeople.postText}</InputGroup.Addon>
                )}
              </InputGroup>
            </Col>
            <Col xs={24} sm={24} md={10} lg={10} style={detailstyles}>
              <InputGroup disabled={isDisabled}>
                <InputGroup.Addon>{item.detail.text}</InputGroup.Addon>
                <Input
                  name={item.detail.name}
                  value={item.detail.value}
                  //inputRef={register}
                  inputRef={register(isValidators(item.detail.validators))}
                  onChange={(e) => {
                    inputDetailChange(e, index)
                    //setTextLength(e.length)
                    schema.criteriaList.options[index].detail.length = e.length
                  }}
                  maxLength={getMaxLengthData(item.detail.validators)?.value}
                />
              </InputGroup>
              <ShowLimitLength
                textLength={item.detail.length || 0}
                maxLength={getMaxLengthData(item.detail.validators)?.value}
              />
            </Col>
          </Row>
        </>
      )
    })
  }

  return (
    <div>
      <Form>
        <Panel accordion bodyFill>
          {isConfirmActualResult ? (
            <>
              <Panel header="" defaultExpanded>
                <b>{schema.targetCriteria.label || 'เกณฑ์การคัดเลือก'} : </b>
                <br />
                <p style={{ padding: 20 }}>{schema?.targetCriteria?.value ?? ''}</p>
              </Panel>
            </>
          ) : (
            <>
              <Panel header="" defaultExpanded>
                {schema.description && <CustomAlertMessageInfo contents={schema.description} />}

                {schema.descriptionNote && (
                  <div style={{ marginTop: 10 }}>
                    <CustomNote data={schema.descriptionNote} />
                  </div>
                )}

                <br />
                <Message
                  showIcon
                  type="warning"
                  description={schema.targetCriteria.alert}
                  style={{ marginBottom: 10 }}
                />
                <label className={isRequired(schema.targetCriteria.validators) ? 'required' : ''}>
                  {schema.targetCriteria.label || 'เกณฑ์การคัดเลือก'}
                </label>
                {errors.targetCriteria && (
                  // <Message showIcon type="error" description={errors.projectFeature.message} />
                  <Message showIcon type="error" description={errors.targetCriteria.message} />
                )}
                <Input
                  componentClass="textarea"
                  rows={3}
                  maxLength={getMaxLengthData(schema.targetCriteria.validators)?.value}
                  name={schema.targetCriteria.name}
                  inputRef={register(isValidators(schema.targetCriteria.validators))}
                  disabled={schema.targetCriteria.disabled}
                  defaultValue={schema.targetCriteria.value}
                  placeholder={schema.targetCriteria.hint}
                  onChange={(e) => {
                    schema.targetCriteria.value = e
                    updateSchemaValue()
                    setTextLength(e.length)
                  }}
                />
                <ShowLimitLength
                  textLength={textLength}
                  maxLength={getMaxLengthData(schema.targetCriteria.validators)?.value}
                />
              </Panel>
            </>
          )}

          <Panel defaultExpanded>
            <CustomIconMessageInfo content={schema.criteriaList.alert} />
            <br />
            {errors.optionSelected && (
              <Message showIcon type="error" description={errors.optionSelected.message} />
            )}
            <Controller
              key={schema.criteriaList.name}
              name={schema.criteriaList.name}
              control={control}
              rules={isValidators(
                schema.criteriaList.validators || [
                  {
                    type: 'REQUIRED',
                    value: null,
                    errorMessage: 'กรุณาเลือก อย่างน้อย 1 รายการ',
                  },
                ]
              )}
              // value={item.numberOfPeople.value}
              defaultValue={checkBoxList}
              render={(props) => {
                return (
                  <CheckboxGroup
                    name={schema.criteriaList.name}
                    value={checkBoxList}
                    onChange={handleChange}
                  >
                    {generateCheckbox()}
                  </CheckboxGroup>
                )
              }}
            />
          </Panel>
        </Panel>
      </Form>
    </div>
  )
}
